import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const NavContainer: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        position: fixed;
        top: 0;
        width: 100%;
        z-index: ${theme.zIndex.zIndexHigh};

        ${theme.breakpoints.down('lg')} {
            display: none;
        }

        a {
            color: inherit;
            text-decoration: none;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default NavContainer;